import {
    GET_NOTICE_LIST_RESPONCE,
    GET_NOTICE_TOTALS_RESPONCE,
    CHNAGE_NOTICE_STATUS_REDUX_STATE,
    NOTICE_VIEW_REPORT_RESPONCE,
    GET_NOTICE_REPORT_DATA_REQUEST,
    GET_NOTICE_REPORT_DATA_SUCCESS,
    GET_NOTICE_REPORT_DATA_FAILURE

} from "./actionTypes";

const INIT_STATE = {
    noticeList: [],
    noticeTotals: null,
    noticeViewReport: []
};

/**
 * Reducer function for managing the state of depots.
 * @param {object} state - The current state of depots.
 * @param {object} action - The action object that contains the type and payload.
 * @returns The updated state of depots.
 */
const noticeManagement = (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_NOTICE_LIST_RESPONCE:
           
            state = {
                ...state,
                noticeList: action?.payload,
              }
              return state;

        case GET_NOTICE_TOTALS_RESPONCE:
            state = {
                ...state,
                noticeTotals: action?.payload?.data?.totalCounts,
            }
            return state;

       case CHNAGE_NOTICE_STATUS_REDUX_STATE:

           state = {
            ...state,
            noticeList: action?.payload

           }
           return state;

        
       case NOTICE_VIEW_REPORT_RESPONCE:

           state = {
            ...state,
            noticeViewReport: action?.payload?.data

           }
           return state;

        case GET_NOTICE_REPORT_DATA_REQUEST:
            return {
                ...state,
                loading: true
            };

        case GET_NOTICE_REPORT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                noticeReportData: action.payload
            };

        case GET_NOTICE_REPORT_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};



export default noticeManagement;